import { translate } from '../../../../../i18n'
import { GContainer, RowSpacerGItem } from '../../grids'
import { DatePickerNoBind } from '../../inputs/datePickerNoBind'

// 日付選択
const DateSelection = (props: {activeDate: Date, onChange: (date:Date | null) => void}) => (
  <GContainer>
    <div>
      {translate('facilityLotteryReservationUpdateSelection.label.selectTheDesiredDateOfUse')}
    </div>
    <DatePickerNoBind fullWidth value={props.activeDate} onChange={props.onChange} />
    <RowSpacerGItem />
  </GContainer>
)
export default DateSelection;